import { Box, Stack, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useTitle } from 'react-use';
import MenuTopBar from './MenuTopBar';
import MenuDrawer from './MenuDrawer';
import { drawerWidth } from './constants';
import { useConfig } from '@/context/ConfigProvider';

const Layout = () => {
  const config = useConfig();
  // Environment in the tab title too, so it is visible when the window is one of twenty.
  useTitle(
    (['staging', 'prod'].includes(config.env) ? '' : `[${config.env}] `) +
      'VMS',
  );

  return (
    <Box sx={{ height: '100%' }}>
      <MenuTopBar />
      <MenuDrawer />
      <Stack
        component="main"
        direction="column"
        sx={{ height: '100%', pl: `${drawerWidth}px` }}
      >
        <Toolbar />
        <Stack direction="column" flexGrow={1} p={4} gap={2} minWidth={0}>
          <Outlet />
        </Stack>
      </Stack>
    </Box>
  );
};

export default Layout;
